import { render, staticRenderFns } from "./listQasHelpdesk.vue?vue&type=template&id=c6e15d30&scoped=true&"
import script from "./listQasHelpdesk.vue?vue&type=script&lang=js&"
export * from "./listQasHelpdesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e15d30",
  null
  
)

export default component.exports